import React from "react";
import PropTypes from "prop-types";
import * as $ from "jquery";
import "fullcalendar";
import tinycolor from "tinycolor2";

const ICONS = {
  prev: "chevron-left",
  next: "chevron-right",
  prevYear: "chevrons-left", // double chevron
  nextYear: "chevrons-right" // double chevron
};

class FullCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.defaultDate = undefined;

    this._render = this._render.bind(this);
  }

  _missingProp(prop) {
    return function() {
      // eslint-disable-next-line no-console
      console.error(
        "Please provide a '" + prop + "' prop on the FullCalendar component"
      );
    };
  }

  _forceRerender() {
    this._render(this.props);
  }

  _render(props, setMiddle = false) {
    const {
      selectable,
      handleSelect,
      events,
      handleClick,
      dayRender,
      validRange,
      handleEdit,
      middle,
      editable,
      settingsOverrides,
      longPressDelay,
    } = props;

    let settings = {
      timeFormat: "H(:mm)",
      firstDay: 1,
      longPressDelay: longPressDelay || 0,
    };

    if (selectable !== undefined) {
      settings.selectable = selectable;
      settings.selectHelper = selectable;
      settings.select = handleSelect
        ? handleSelect
        : this._missingProp("handleSelect");
    }

    if (handleEdit !== undefined) {
      settings.eventDurationEditable = true;
      settings.eventStartEditable = true;
      settings.editable = true;
      settings.eventDrop = handleEdit;
      settings.eventResize = handleEdit;
    }

    if (events !== undefined) {
      settings.events = events;
    }

    if (editable !== undefined) {
      settings.editable = editable;
    }

    settings.buttonIcons = ICONS;

    if (dayRender !== undefined) {
      settings.dayRender = dayRender;
    }

    if (validRange !== undefined) {
      settings.validRange = validRange;
    }

    settings.eventRender = function(event, element) {
      if (event.color && !event.textColor) {
        console.log("adjusting event render");
        element.find(".fc-title").css({
          color:
            tinycolor(event.color).getBrightness() < 180 ? "#FFFFFF" : "#000000"
        });
      } else if (event.textColor) {
        element.find(".fc-title").css({
          color: event.textColor
        });
      }

      element.find(".fc-time").remove();
    };

    const $cal = $("#calendar");

    // Zet middle op componentWillMount
    if (
      middle &&
      (setMiddle ||
        !this.props.middle ||
        middle.format("DD/MM/YYYY") !== this.props.middle.format("DD/MM/YYYY"))
    ) {
      settings.defaultDate = middle;
      this.defaultDate = middle;
    }

    // herzet midden op componentWillReceiveProps
    if (!setMiddle && this.defaultDate) {
      settings.defaultDate = this.defaultDate;
    }

    // Hou midden bij bij page changes
    settings.viewRender = (view, element) => {
      if (!setMiddle) {
        this.defaultDate = view.intervalStart;
      }
    };

    if (handleClick) {
      // props (calEvent, jsEvent, view)
      settings.eventClick = handleClick;
    }

    settings = { ...settings, ...settingsOverrides };

    $cal.css({ "min-height": $cal.height() });
    $cal.fullCalendar("destroy");
    $cal.fullCalendar(settings);
    $cal.removeAttr("style");
  }

  componentDidMount() {
    this._render(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._render(nextProps);
  }

  static propTypes = {
    selectable: PropTypes.bool,
    handleSelect: PropTypes.func,
    middle: PropTypes.object,
    settingsOverrides: PropTypes.object
  };

  render() {
    return <div id="calendar" />;
  }
}

export default FullCalendar;
